import {
  Box,
  CircularProgress,
  CircularProgressProps as MUICircularProgressProps,
  Typography,
} from '@mui/material';
import {forwardRef, Ref, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {ThemeMode} from '../../enums/theme-mode';
import {translations} from '../../i18n/translations';

/**
 * Loading indicator.
 */

interface LoadingContentProps extends MUICircularProgressProps {
  marginTop?: string;
}

export const LoadingContent = forwardRef(
  (props: LoadingContentProps, ref: Ref<HTMLSpanElement>) => {
    // Get context
    const appContext: AppContextType = useContext(AppContext);

    // Translations
    const {t} = useTranslation();

    // Default result
    return (
      <Box
        className={props.className}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: props.marginTop ? props.marginTop : '0px',
          ...props.sx,
        }}
      >
        <CircularProgress
          ref={ref}
          color={appContext.state.currentThemeMode === ThemeMode.Dark ? 'control' : 'primary'}
          size={24}
        />
        <Typography
          variant="body2"
          align="center"
          sx={{
            paddingTop: '6px',
          }}
        >
          {t(translations.loading_content.loading)}
        </Typography>
      </Box>
    );
  }
);
